export const getDeadlineItem = (service, deadlines, file) => {
    if (!file.duration) {
        return undefined;
    }

    const deadline = deadlines[service].find(deadline => {
        return deadline.duration > file.duration;
    });

    return deadline || console.log('Deadline not found.', file);
};